import React from 'react'
import { Input } from '@arnsbogroup/react-voicearchive'

const NumberInput = ({ descriptor, value, onChange }) => (
  <div>
    <Input
      label={descriptor.label}
      placeholder={descriptor.placeholder ?? ''}
      size="base"
      value={value ?? ''}
      onChange={e => onChange(descriptor.key, e.target.value)}
      type="number"
    />
  </div>
)

export default NumberInput
